<script setup>
import {onMounted, ref, reactive} from "vue";
import router from "@/router/index.js";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import YTCheckPanel from "@/components/YTCheckedPanel/index.vue";
import YTTagGroup from "@/components/YTTagGroup/index.vue";
import {
  deleteCyclingRoute,
  editCyclingRouteLinkTag,
  listCyclingRoute,
} from "@/api/cyclingRoute/cyclingRoute.js";
import {tagsScenarioList} from "@/api/tag/tag.js";

/*初次加载*/
onMounted(async () => {
  await handleGetTagsList()
  await handleSearch()
})

/*权限相关*/

/*搜索功能*/
// 表单数据
const formData = reactive({
  routeName: null,
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnClick') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listCyclingRoute(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.routeName = null
  YTTablePaginationRef.value.resetPage()
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const panelLoading = ref(false)
const headers = ref([
  { title: '线路名', key: 'routeName', minWidth: "120px", nowrap: true },
  { title: '城市', key: 'city', minWidth: "200px", nowrap: true },
  { title: '长度（KM）', key: 'routeLength', minWidth: "120px", maxWidth: "150xp", nowrap: true },
  { title: '标签', key: 'tagList', maxWidth: "120px" },
  { title: '操作', key: 'controls', minWidth: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 展示的详情信息
const detailInfo = ref()
// 获取详情信息
const getDetail = (info) => {
  detailInfo.value = info
  router.push({path: "/editCyclingRoute", query: {cyclingRouteId: detailInfo.value.cyclingRouteId}})
}

// 标签缓存信息
const cacheItem = ref()
// 标签多选框打开状态
const openTags = ref(false)
// 标签数据
const listTags = ref([])
// 获取标签列表
const handleGetTagsList = async () =>  {
  try {
    const param = ref({
      page: tagsPage.value,
      pageSize: 10
    })
    panelLoading.value = true
    const res = await tagsScenarioList(param.value, {usageScenario: "CYCLING_ROUTE"})
    listTags.value = []
    res.list.forEach((item) => {
      const param = {
        name: item.tagName,
        value: item.tagId
      }
      listTags.value.push(param)
    })
    tagsTotal.value = parseInt(res.total)
    panelLoading.value = false
  } catch (e) {
    console.log(e)
    panelLoading.value = false
  }
}
// 设置标签，打开选择对话框
const setTags = (item) => {
  cacheItem.value = item
  openTags.value = true
}
// 确认选择标签
const handlePanelTagsConfirm = async (item) => {
  const param = {
    cyclingRouteId: cacheItem.value.cyclingRouteId,
    tagIdList: item
  }
  try {
    await editCyclingRouteLinkTag(param)
    await handleSearch()
    ElMessage.success("修改标签成功")
  } catch (e) {
    console.log(e)
  }
  openTags.value = false
}
// 取消选择标签
const handlePanelTagsClose = () => {
  cacheItem.value = null
  openTags.value = false
}
// 标签总条数
const tagsTotal = ref(0)
// 标签当前页
const tagsPage = ref(1)
// 处理标签翻页
const handleChangeTagsPage = () => {
  handleGetTagsList()
}

/*删除操作对话框*/
const dialogConfirm = async (item) => {
  try {
    loading.value = true
    await deleteCyclingRoute(item.cyclingRouteId)
    loading.value = false
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}

/*跳转新建*/
const handleAdd = () => {
  router.push("/editCyclingRoute")
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd" :disabled="!$handleHasBtnPermission('all', 'cyclingRoute:add')">新建线路</v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="4">
                    <v-text-field
                        v-model="formData.routeName"
                        placeholder="请输入线路名"
                        label="线路名"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" offset="5">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnClick')" :disabled="!$handleHasBtnPermission('all', 'cyclingRoute:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'cyclingRoute:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.tagList="{ item }">
            <div>
              <YTTagGroup :isColumn="true" :list="item.tagList.map(res => res.tagName)"></YTTagGroup>
            </div>
          </template>

          <template v-slot:item.operatingHours="{ item }">
            <div>
              <div v-for="item in item.operatingHours">
                {{item.weekdayOpen}}至{{item.weekdayClose}} {{item.operatingStart}} - {{item.operatingEnd}}
              </div>
            </div>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon icon="mdi-file-edit-outline" v-if="$handleHasBtnPermission('all', 'cyclingRoute:edit')" color="primary" size="small" @click="getDetail(item)"></v-icon>
              </el-tooltip>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="标签"
                  placement="top">
                <v-icon class="mg_l_1" icon="mdi-tag-outline" color="success" @click="setTags(item)" v-if="$handleHasBtnPermission('all', 'cyclingRouteTag:edit')"></v-icon>
              </el-tooltip>
              <el-popconfirm @confirm="dialogConfirm(item)" :title="`确定删除线路 “${item.routeName}” 吗？`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right"
                        @click.stop>
                      <v-icon class="cursor-pointer" color="error" icon="mdi-close" v-if="$handleHasBtnPermission('all', 'cyclingRoute:delete')"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>


  <YTCheckPanel
      v-if="openTags"
      :open="openTags"
      :title="`${cacheItem.routeName} - 标签`"
      :checkedList="cacheItem.tagList.map(res => res.tagId)"
      :list="listTags"
      :hasAll="false"
      :checkedLimit="6"
      @cancel="handlePanelTagsClose"
      @confirm="handlePanelTagsConfirm"
      :maxWidth="600"
  >
    <template v-slot:pagination>
      <div class="flex_right text-right pt-2" style="width: 100%;">
        <v-pagination
            v-model="tagsPage"
            :length="Math.ceil(tagsTotal / 10)"
            :total-visible="6"
            @update:modelValue="handleChangeTagsPage"
            v-if="tagsTotal > 0"
        ></v-pagination>
      </div>
    </template>
  </YTCheckPanel>
</template>

<style scoped>

</style>
